import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import store from '/'
import da from "element-ui/src/locale/lang/da";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 上一页地址
        previousPage: "",
        rootColor: localStorage.getItem("rootColor") || sessionStorage.getItem("rootColor") || "",
        rootOptColor: localStorage.getItem("rootOptColor") || sessionStorage.getItem("rootOptColor") || "",
        token: localStorage.getItem("index-token") || "",
        isLogin: localStorage.getItem("isLogin") || "0", // 只有1为已登录
        userInfo: JSON.parse(localStorage.getItem("userInfo")) || {}, // 用户信息
        asideWidth: localStorage.getItem("isCollapse") === 'true' ? '0px' : '256px' || '256px',
        isCollapse: localStorage.getItem("isCollapse") === 'true' ? true : false || false,// 控制侧边栏是否折叠 false-展开 true-折叠
        activePath: localStorage.getItem("activePath") || '/record/statistics', // 当前选中的menu
        session: localStorage.getItem("session") || '0', // 当前选中的场次
        link: localStorage.getItem("link") || '0', // 当前选中的环节
        tier: localStorage.getItem("tier") || '全量', // 当前选中的环节下选中的层级
        sessionList: JSON.parse(localStorage.getItem("sessionList")) || [], // 场次列表
        linkList: JSON.parse(localStorage.getItem("linkList")) || [], // 环节列表
        tierList: JSON.parse(localStorage.getItem("tierList")) || [], // 当前环节下的层级列表
        groupConfig: localStorage.getItem("groupConfig") || '{}', // 面试组配置
        showConfigLink: false, // 控制配置数据查看弹框显示与隐藏
        showConfigGroup: false, // 控制配置进度查看弹框显示与隐藏
        isOverMax: (localStorage.getItem("isOverMax") === 'true' ? true : false) || false,// 最小层级是否超过100人
    },
    getters: {
        getUserInfo(state) {
            return state.userInfo;
        },
        getAsideWidth(state) {
            return state.asideWidth;
        },
        getCollapse(state) {
            return state.isCollapse;
        },
        getActivePath(state) {
            return state.activePath;
        },
        getSession(state) {
            return Number(state.session);
        },
        getLink(state) {
            return state.link;
        },
        getTier(state) {
            return state.tier;
        },
        getSessionList(state) {
            return state.sessionList;
        },
        getLinkList(state) {
            return state.linkList;
        },
        getTierList(state) {
            return state.tierList;
        },
        // 获取带有【全量】的层级列表
        getTierQList(state) {
            return ['全量', ...state.tierList];
        },
        // 获取所有环节中层级的并集列表
        getTierAllList(state) {
            return ['全量', ...state.tierList];
        },
        getGroupConfig(state) {
            return JSON.parse(state.groupConfig);
        },
        getShowConfigLink(state) {
            return state.showConfigLink;
        },
        getShowConfigGroup(state) {
            return state.showConfigGroup;
        },
        getIsOverMax(state) {
            return state.isOverMax;
        }
    },
    mutations: {
        setRootColor(state, data) {
            state.rootColor = data.color;
            state.rootOptColor = data.color_opt;
            localStorage.setItem("rootColor", data.color);
            localStorage.setItem("rootOptColor", data.color_opt);
        },
        // 更新上一页信息
        setPrePage(state, path) {
            state.previousPage = path;
        },
        login(state, data) {
            state.isLogin = "1";
            state.token = data;
            localStorage.setItem("isLogin", "1");
            localStorage.setItem("index-token", data);
        },
        loginOut(state) {
            state.isLogin = "0";
            state.token = "";
            state.userInfo = {};
            state.activePath = "/record/statistics";
            let rootColor = localStorage.getItem("rootColor");
            let rootOptColor = localStorage.getItem("rootOptColor")
            if (rootColor != null && rootOptColor != null) {
                // 浏览器关闭，会被销毁
                sessionStorage.setItem("rootColor", rootColor);
                sessionStorage.setItem("rootOptColor", rootOptColor);
            }
            localStorage.clear();
            router.replace('/login').catch();
        },
        setUserInfo(state, data) {
            state.userInfo = data;
            localStorage.setItem("userInfo", JSON.stringify(data));
        },
        setCollapse(state) {
            let status = !state.isCollapse;
            state.asideWidth = status ? '0px' : '256px';
            state.isCollapse = status;
            localStorage.setItem("isCollapse", status.toString());
        },
        setActivePath(state, data) {
            state.activePath = data;
            localStorage.setItem("activePath", data);
            router.push(data).catch();
        },
        setSession(state, data) {
            state.session = data;
            localStorage.setItem("session", data);
        },
        setLink(state, data) {
            let linkList = state.linkList;
            let tierList = [];
            linkList.map((item) => {
                if (item.uuid == data) {
                    tierList = item.location;
                }
            })
            state.link = data;
            state.tier = '全量';
            state.tierList = tierList;
            localStorage.setItem("link", data);
            localStorage.setItem("tier", '全量');
            localStorage.setItem("tierList", JSON.stringify(tierList));
            for (let key in localStorage) {
                if (key.indexOf('local_search_') != -1) {
                    localStorage.removeItem(key);
                }
            }
        },
        setTier(state, data) {
            state.tier = data;
            localStorage.setItem("tier", data);
        },
        setSessionList(state, data) {
            state.sessionList = data;
            localStorage.setItem("sessionList", JSON.stringify(data));
        },
        setLinkList(state, data) {
            state.linkList = data;
            localStorage.setItem("linkList", JSON.stringify(data));
            for (let key in localStorage) {
                if (key.indexOf('local_search_') != -1) {
                    localStorage.removeItem(key);
                }
            }
        },
        setTierList(state, data) {
            state.tierList = data;
            localStorage.setItem("tierList", JSON.stringify(data));
        },
        setGroupConfig(state, data) {
            state.groupConfig = JSON.stringify(data);
            localStorage.setItem("groupConfig", JSON.stringify(data));
        },
        setShowConfigLink(state, data) {
            state.showConfigLink = data;
        },
        setShowConfigGroup(state, data) {
            state.showConfigGroup = data;
        },
        setIsOverMax(state, data) {
            state.isOverMax = data;
            localStorage.setItem("isOverMax", data);
        }

    },
    actions: {},
    modules: {}
})
